export const Active = "Active"
export const InActive = "InActive"
export const active = "active"
export const inActive = "inActive"
export const performanceDate = "performanceDate"
export const performanceEmpCode = "performanceEmpCode"

